import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import styles from './Share.styles';

export interface ShareIconProps extends WithStyles<typeof styles> {
  color?: string;
}

const ShareIconComponent: FC<ShareIconProps> = ({ classes, color = '#7E8899' }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      classes={{ root: classes.root }}
    >
      <path
        d="M13.8609 8.40489C14.0237 8.26539 14.105 8.19564 14.1348 8.11264C14.161 8.03979 14.161 7.96011 14.1348 7.88726C14.105 7.80426 14.0237 7.73451 13.8609 7.59501L8.21375 2.7546C7.9336 2.51447 7.79353 2.3944 7.67493 2.39146C7.57186 2.3889 7.47341 2.43418 7.40828 2.5141C7.33333 2.60606 7.33333 2.79055 7.33333 3.15953V6.02304C5.91021 6.27201 4.60773 6.99312 3.63981 8.07586C2.58455 9.25629 2.00082 10.7839 2 12.3673V12.7753C2.69956 11.9325 3.573 11.251 4.56051 10.7772C5.43113 10.3596 6.37228 10.1122 7.33333 10.047V12.8404C7.33333 13.2093 7.33333 13.3938 7.40828 13.4858C7.47341 13.5657 7.57186 13.611 7.67493 13.6084C7.79353 13.6055 7.9336 13.4854 8.21375 13.2453L13.8609 8.40489Z"
        stroke={color}
        strokeOpacity="0.65"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ShareIcon = withStyles(styles)(ShareIconComponent);
